import About from "./About";
import Home from "./Home";
import Project from "./Projects";
import Skill from "./Skill";
import Timeline from "./Timeline";

const Landingpage = () => {
    return ( 
        <>
            <Home />
            <About />
            <Skill />
            <Timeline />
            <Project />
        </>
     );
}
 
export default Landingpage;